import {
  TierPromotionCreateBody,
  TierPromotionListResponse,
  TierPromotionItem,
  TierPromotionDetailResponse,
} from "utils/api/client/types"

export class TierPromotion {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }
  create(
    vendorId: string,
    body: TierPromotionCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<TierPromotionItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/tier-promotions`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }

  update(
    id: string,
    vendorId: string,
    body: TierPromotionCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<TierPromotionItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/tier-promotions/${id}`,
        {
          method: "PUT",
          headers,
          body,
          query,
        }
      )
    })()
  }

  list(
    vendorId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<TierPromotionListResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/tier-promotions`,
        {
          headers,
          query: queryParams,
        }
      )
    })()
  }

  retrieve(
    id: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<TierPromotionDetailResponse> {
    return (async () => {
      const { vendorId, ...reset } = queryParams as any
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/tier-promotions/${id}`,
        {
          query: reset,
          headers,
        }
      )
    })()
  }

  delete(
    id: string,
    vendorId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/tier-promotions/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }

  duplicate(
    id: string,
    vendorId: string,
    body: { name: string },
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/tier-promotions/${id}/duplicate`,
        {
          method: "POST",
          headers,
          body,
        }
      )
    })()
  }
}
